import React from 'react';
import { MonogramPattern } from '../brand/MonogramPattern';
import { ButtonLink } from './ButtonLink';
import { Reveal } from '../motion/Reveal';
import { discussSearchHref } from '../../data/navigation';
type CallToActionProps = {
  title?: string;
  text?: string;
};
export function CallToAction({
  title = 'Let’s Find the Right Talent for What’s Next.',
  text = 'Whether you are planning a senior appointment, strengthening your board or exploring the talent market, we would welcome a confidential conversation.'
}: CallToActionProps) {
  return <section className="relative overflow-hidden bg-navy" aria-labelledby="cta-title" data-id="element-299" data-mp="1zhb5az767auh">
      <MonogramPattern className="pointer-events-none absolute -bottom-40 left-1/2 hidden h-[160%] -translate-x-1/2 text-gold opacity-[0.12] sm:block" data-id="element-300" data-mp="1vdva87ar1ijw" />
      <Reveal className="relative mx-auto max-w-4xl px-5 py-24 text-center sm:px-8 lg:py-32" data-id="element-301" data-mp="3prwa8vi1cblk">
        <span aria-hidden="true" className="mx-auto block h-px w-12 bg-gold" data-id="element-302" data-mp="3ks034ne1k41s" />
        <h2 id="cta-title" className="mt-8 font-serif text-[2.5rem] font-medium leading-[1.08] text-white sm:text-[3.5rem]" data-id="element-303" data-mp="2enmthyapz666">
          {title}
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-white/75" data-id="element-304" data-mp="2jkd6udv53nnw">{text}</p>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-305" data-mp="25p18zxloth2r">
          <ButtonLink to={discussSearchHref} variant="gold" data-id="element-306" data-mp="2amb9q9ej1f5w">
            Discuss a Search
          </ButtonLink>
          <ButtonLink to="/our-team" variant="outlineLight" data-id="element-307" data-mp="2ydqes9xouaku">
            Meet Our Team
          </ButtonLink>
        </div>
      </Reveal>
    </section>;
}